import AppBar from "@material-ui/core/AppBar"
import Button from "@material-ui/core/Button"
import { makeStyles } from "@material-ui/core/styles"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
import { useHistory } from "react-router-dom"

import {
    Badge,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Drawer,
    List,
    ListItem,
    ListItemText,
    Popover,
    Tooltip,
    useMediaQuery,
    useTheme,
} from "@material-ui/core"
import IconButton from "@material-ui/core/IconButton"
import {
    AccessAlarm,
    AddBox,
    AttachFile,
    Chat,
    ChevronLeft,
    ChevronRight,
    Dashboard,
    Menu,
    MenuBook,
    Notifications,
    PostAdd,
    Receipt,
    Send,
    Settings,
    Store,
} from "@material-ui/icons"
import ExitToAppIcon from "@material-ui/icons/ExitToApp"
import { Alert } from "@material-ui/lab"
import clsx from "clsx"
import { useContext, useState } from "react"

import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import useParametros from "../../contexts/ParametrosContext"
import ServicosContext from "../../contexts/servicosContext"
import useAppStore from "../../stores/AppStore"
import { clearWhatsappOfficialSession } from "../../utils/whatsappOfficialSession"
import DialogAlterarEstabelecimento from "../DialogAlterarEstabelecimento"

const drawerWidth = 250
const miniDrawerWidth = 80

const useStyles = makeStyles((theme, openBarraLateral) => ({
    root: {
        display: "flex",
    },
    appBar: {
        width: `calc(100% - ${miniDrawerWidth}px)`,
        marginLeft: miniDrawerWidth,
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        [theme.breakpoints.down("md")]: {
            width: "100%",
            marginLeft: 0,
        },
    },
    painelInstaladoStyle: {},
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        [theme.breakpoints.down("md")]: {
            width: "100%",
            marginLeft: 0,
        },
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up("lg")]: {
            display: "none",
        },
    },
    drawer: {
        position: "fixed",
        zIndex: 3,
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
        [theme.breakpoints.down("md")]: {
            display: "none",
        },
    },
    mobileDrawer: {
        [theme.breakpoints.up("lg")]: {
            display: "none",
        },
    },
    drawerOpen: {
        zIndex: 10,
        width: drawerWidth,
        background: "linear-gradient(180deg, #3e3e3e 0%, #1f1f1f 100%)",
        color: "white",
        borderRight: "none",
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),

        "& .MuiTypography-root": { color: "#bdc3c7" },
        "& .MuiSvgIcon-root": { color: "#bdc3c7" },

        "& .MuiListItem-root": {
            borderRadius: 8,
            margin: "2px 8px",
            paddingLeft: 10,
            "&:hover": {
                backgroundColor: "rgba(255,255,255,0.08)",
                "& .MuiTypography-root, & .MuiSvgIcon-root": { color: "#fff" },
            },
        },
    },
    drawerClose: {
        zIndex: 10,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: "hidden",
        width: miniDrawerWidth,
        backgroundColor: "#3e3e3e",
        color: "white",
        borderRight: "none",
        [theme.breakpoints.up("sm")]: {
            width: miniDrawerWidth,
        },
        "& .MuiListItem-root": {
            color: "#bdc3c7",
            margin: "2px 8px",
            borderRadius: "8px",
            "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                color: "white",
            },
        },
        "& .MuiSvgIcon-root": {
            color: "#bdc3c7",
        },
        "& .MuiIconButton-root": {
            color: "#bdc3c7",
            "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                color: "white",
            },
        },
    },
    drawerHeader: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
        justifyContent: "space-between",
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: miniDrawerWidth,
        [theme.breakpoints.down("md")]: {
            marginLeft: 0,
        },
    },
    lista: {
        width: "100%",
    },
    scrollbarCustom: {
        "&::-webkit-scrollbar": {
            width: "8px",
        },
        "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
        },
        "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
            background: "#555",
        },
    },
    botaoAviso: {
        color: "yellow",
        margin: "0 1rem",
        "& > span > span": {
            "& > span": {
                backgroundColor: "white",
                color: "black",
            },
        },
    },
    botaoGerarQRCode: {
        "@media (max-width: 500px)": {
            display: "none",
        },
    },
    botoesMenu: {
        backgroundColor: "#0277BD",
        borderRadius: "10px",
        margin: "0.1em",
        color: "#fafafa",
        "&:hover": {
            backgroundColor: "#01579B",
        },
    },
    drawerHeaderMini: {
        display: "flex",
        alignItems: "center",
        padding: "4px",
        paddingInline: "0.8rem",
        justifyContent: "end",
    },
    sectionLabel: {
        color: "#9aa0a6",
        fontSize: 12,
        letterSpacing: 0.6,
        textTransform: "uppercase",
        padding: "12px 16px 6px",
    },
    billBanner: {
        margin: "8px auto",
        padding: "10px 12px",
        backgroundColor: "#27ae60",
        borderRadius: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        color: "white",
        cursor: "pointer",
        width: "90%",
        "&:hover": {
            backgroundColor: "#219150",
        },
    },
    listItemIcon: { minWidth: 36 },
    listItemText: { "& .MuiTypography-root": { fontSize: 14 } },
}))

export default function Cabecalho(props) {
    const history = useHistory()
    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("md"))
    const configs = useAppStore(s => s.configuracoes)
    const parametros = useParametros()

    const {
        icone,
        pagina,
        subtitulo,
        desconectar,
        registrarPedidoMesa,
        trocarEstabelecimento,
        estabelecimentos,
        gerarQRCode,
        avisoDoisRecebedores,
        botaoModoVisualizacao,
        alertas,
        openAlertas,
        telasEdicao,
    } = props

    const {
        handleRegistradorDePedidos,
        handleAceitadorDePedidos,
        handleNotaFiscal,
        handleIzzaBot,
        handleGeradorQrCode,
        handlePedidoDeMesa,
        handleHome,
        handleAreaDeEntrega,
        handleAgendamentoDeEntrega,
        handleSistemaAdm,
        handleFatura,
    } = useContext(ServicosContext)

    const setTabStatus = useAppStore(s => s.setTabStatus)

    const [openBarraLateral, setOpen] = useState(false)
    const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false)
    const classes = useStyles()

    const handleDrawerOpen = () => {
        if (mobile) {
            setMobileDrawerOpen(true)
        } else {
            setOpen(true)
        }
    }

    const handleDrawerClose = () => {
        if (mobile) {
            setMobileDrawerOpen(false)
        } else {
            setOpen(false)
        }
    }

    const handleMobileDrawerToggle = () => {
        setMobileDrawerOpen(!mobileDrawerOpen)
    }

    const { tela } = useParams()
    const [openDialogAlterarEstabelecimento, setOpenDialogAlterarEstabelecimento] = useState(false)
    const handleToggleDialogAlterarEstabelecimento = () => {
        setOpenDialogAlterarEstabelecimento(prev => !prev)
    }

    const handleClose = () => {
        if (history.length > 1) {
            history.goBack()
        } else {
            history.push("/servicos")
        }
    }

    const [anchorElUtilitarios, setAnchorElUtilitarios] = useState(null)
    const openUtilitarios = Boolean(anchorElUtilitarios)
    const handleOpenUtilitarios = event => setAnchorElUtilitarios(event.currentTarget)
    const handleCloseUtilitarios = () => setAnchorElUtilitarios(null)

    const [anchorAgendamento, setAnchorAgendamento] = useState(null)
    const openAagendamento = Boolean(anchorAgendamento)
    const handleOpenAgendamento = event => setAnchorAgendamento(event.currentTarget)
    const handleCloseAgendamento = () => setAnchorAgendamento(null)

    const [anchorElCardapio, setAnchorElCardapio] = useState(null)
    const openCardapio = Boolean(anchorElCardapio)
    const handleOpenCardapio = event => setAnchorElCardapio(event.currentTarget)
    const handleCloseCardapio = () => setAnchorElCardapio(null)

    const [anchorElPedidos, setAnchorElPedidos] = useState(null)
    const openPedidos = Boolean(anchorElPedidos)
    const handleOpenPedidos = e => setAnchorElPedidos(e.currentTarget)
    const handleClosePedidos = () => setAnchorElPedidos(null)

    const [anchorElCadastros, setAnchorElCadastros] = useState(null)
    const openCadastros = Boolean(anchorElCadastros)
    const handleOpenCadastros = e => setAnchorElCadastros(e.currentTarget)
    const handleCloseCadastros = () => setAnchorElCadastros(null)

    const [anchorElFinanceiro, setAnchorElFinanceiro] = useState(null)
    const openFinanceiro = Boolean(anchorElFinanceiro)
    const handleOpenFinanceiro = e => setAnchorElFinanceiro(e.currentTarget)
    const handleCloseFinanceiro = () => setAnchorElFinanceiro(null)

    const estabelecimentoId = configs.user.parametros.estabelecimento.id
    const perfilUsuario = configs.user.perfil
    const isPerfilWhatsappOperador = perfilUsuario === "WHATSAPP"
    const mostrarCardapio = perfilUsuario !== "DELIVERY_BASICO"
    const painelInstalado = sessionStorage.getItem("direcionamentoInicial")

    const [dialogSair, setDialogSair] = useState(false)
    const handleSair = () => {
        clearWhatsappOfficialSession()
        localStorage.removeItem("chaveSistema")
        localStorage.removeItem("dataUltimoServico")
        window.name = ""
        history.push("/login")
    }

    const menuContent = () => {
        if (isPerfilWhatsappOperador) {
            return (
                <>
                    <List className={classes.lista}>
                        <ListItem
                            button
                            onClick={() => {
                                history.push("/servicos")
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <div className={classes.listItemIcon}>
                                    <Dashboard />
                                </div>
                                <ListItemText primary="Menu" className={classes.listItemText} />
                            </div>
                        </ListItem>
                        <ListItem
                            button
                            onClick={() => history.push("/servicos/modulo/conversas-whatsapp")}
                        >
                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <div className={classes.listItemIcon}>
                                    <Chat />
                                </div>
                                <ListItemText primary="Chat" className={classes.listItemText} />
                            </div>
                        </ListItem>
                        <ListItem
                            button
                            onClick={() =>
                                history.push("/servicos/modulo/criar-template-whatsapp")
                            }
                        >
                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <div className={classes.listItemIcon}>
                                    <PostAdd />
                                </div>
                                <ListItemText
                                    primary="Cadastrar templates"
                                    className={classes.listItemText}
                                />
                            </div>
                        </ListItem>
                        <ListItem
                            button
                            onClick={() =>
                                history.push("/servicos/modulo/envio-template-whatsapp-grupo")
                            }
                        >
                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <div className={classes.listItemIcon}>
                                    <Send />
                                </div>
                                <ListItemText
                                    primary="Disparar templates"
                                    className={classes.listItemText}
                                />
                            </div>
                        </ListItem>
                        <ListItem
                            button
                            onClick={() => {
                                setDialogSair(true)
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <div className={classes.listItemIcon}>
                                    <ExitToAppIcon />
                                </div>
                                <ListItemText primary="Sair" className={classes.listItemText} />
                            </div>
                        </ListItem>
                    </List>
                </>
            )
        }

        return (
            <>
                <List className={classes.lista}>
                    {/* <ListItem button onClick={handleFatura} className={classes.billBanner}>
                        <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                            Fatura Disponível
                        </Typography>
                    </ListItem> */}

                    <ListItem button onClick={handleSistemaAdm}>
                        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                            <div className={classes.listItemIcon}>
                                <AttachFile />
                            </div>
                            <ListItemText
                                primary="Sistema Administrativo"
                                className={classes.listItemText}
                            />
                        </div>
                    </ListItem>

                    <ListItem
                        button
                        onClick={() => {
                            history.push("/servicos")
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                            <div className={classes.listItemIcon}>
                                <Dashboard />
                            </div>
                            <ListItemText primary="Menu" className={classes.listItemText} />
                        </div>
                    </ListItem>

                    <ListItem button onClick={handleOpenPedidos}>
                        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                            <div className={classes.listItemIcon}>
                                <Receipt />
                            </div>
                            <ListItemText primary="Pedidos" className={classes.listItemText} />
                        </div>
                        <ChevronRight style={{ opacity: 0.6 }} />
                    </ListItem>

                    <ListItem button onClick={handleOpenCardapio}>
                        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                            <div className={classes.listItemIcon}>
                                <MenuBook />
                            </div>
                            <ListItemText primary="Cardápio" className={classes.listItemText} />
                        </div>
                        <ChevronRight style={{ opacity: 0.6 }} />
                    </ListItem>

                    <ListItem button onClick={handleOpenCadastros}>
                        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                            <div className={classes.listItemIcon}>
                                <AddBox />
                            </div>
                            <ListItemText primary="Cadastros" className={classes.listItemText} />
                        </div>
                        <ChevronRight style={{ opacity: 0.6 }} />
                    </ListItem>

                    <ListItem button onClick={handleOpenFinanceiro}>
                        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                            <div className={classes.listItemIcon}>
                                <Store />
                            </div>
                            <ListItemText primary="Financeiro" className={classes.listItemText} />
                        </div>
                        <ChevronRight style={{ opacity: 0.6 }} />
                    </ListItem>

                    {parametros.PUBLIC_HABILITAR_AGENDAMENTO && (
                        <ListItem button onClick={handleOpenAgendamento}>
                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <div className={classes.listItemIcon}>
                                    <AccessAlarm />
                                </div>
                                <ListItemText
                                    primary="Agendamento"
                                    className={classes.listItemText}
                                />
                            </div>
                            <ChevronRight style={{ opacity: 0.6 }} />
                        </ListItem>
                    )}
                    <ListItem button onClick={handleOpenUtilitarios}>
                        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                            <div className={classes.listItemIcon}>
                                <Settings />
                            </div>
                            <ListItemText primary="Utilitários" className={classes.listItemText} />
                        </div>
                        <ChevronRight style={{ opacity: 0.6 }} />
                    </ListItem>

                    <ListItem
                        button
                        onClick={() => {
                            setDialogSair(true)
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                            <div className={classes.listItemIcon}>
                                <ExitToAppIcon />
                            </div>
                            <ListItemText primary="Sair" className={classes.listItemText} />
                        </div>
                    </ListItem>
                </List>
            </>
        )
    }

    return (
        <>
            <Dialog open={dialogSair} onClose={() => setDialogSair(false)}>
                <DialogTitle>Deseja sair da sua conta?</DialogTitle>
                <DialogContent>
                    <Typography>
                        Você está prestes a encerrar sua sessão. Para continuar usando o painel,
                        será necessário fazer login novamente.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        style={{ backgroundColor: "green", color: "white" }}
                        onClick={() => {
                            setDialogSair(false)
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        style={{ backgroundColor: "red", color: "white" }}
                        onClick={handleSair}
                    >
                        Sair
                    </Button>
                </DialogActions>
            </Dialog>
            <DialogAlterarEstabelecimento
                open={openDialogAlterarEstabelecimento}
                handleToggleDialogAlterarEstabelecimento={handleToggleDialogAlterarEstabelecimento}
            />
            <div className={classes.root} id="cabecalhoApp">
                <AppBar
                    position="fixed"
                    className={clsx(classes.appBar, {
                        [classes.appBarShift]: openBarraLateral,
                    })}
                >
                    <Toolbar
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            maxWidth: "100vw",
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center" }}>
                            {mobile && (
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    onClick={handleMobileDrawerToggle}
                                    className={classes.menuButton}
                                    size="small"
                                >
                                    <Menu />
                                </IconButton>
                            )}

                            {icone && (
                                <div
                                    className={classes.iconeImg}
                                    color="inherit"
                                    aria-label="open drawer"
                                >
                                    <img
                                        src={icone}
                                        style={{
                                            height: "50px",
                                            borderRadius: "100%",
                                        }}
                                        alt=""
                                    />
                                </div>
                            )}
                            <Typography
                                className={classes.title}
                                variant="h6"
                                noWrap
                                style={{ marginLeft: "1em", maxWidth: "50vw" }}
                            >
                                {pagina}{" "}
                                {subtitulo && (
                                    <span style={{ fontSize: "50%", color: "gray" }}>
                                        {subtitulo}
                                    </span>
                                )}
                            </Typography>
                        </div>

                        <div style={{ display: "flex", alignItems: "center" }}>
                            {desconectar && (
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    edge="end"
                                    onClick={desconectar}
                                >
                                    <ExitToAppIcon />
                                </IconButton>
                            )}
                            {registrarPedidoMesa && (
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    edge="end"
                                    onClick={registrarPedidoMesa}
                                >
                                    Registrar
                                </IconButton>
                            )}
                            {trocarEstabelecimento && (
                                <Button
                                    onClick={() =>
                                        history.push("/servicos/ferramenta/pedido-de-mesa")
                                    }
                                    variant="contained"
                                >
                                    <span className="no-mobile">Gerar</span> QRCodes
                                </Button>
                            )}

                            {avisoDoisRecebedores && (
                                <div id="aviso-dois-recebedores" style={{ display: "none" }}>
                                    <Tooltip
                                        arrow
                                        title="Mais de um recebedor aberto pode impactar no recebimento automático dos seus pedidos."
                                    >
                                        <Alert severity="info" elevation={3}>
                                            Há outro recebedor aberto
                                        </Alert>
                                    </Tooltip>
                                </div>
                            )}

                            {alertas?.length && (
                                <IconButton className={classes.botaoAviso} onClick={openAlertas}>
                                    <Badge
                                        badgeContent={alertas.length}
                                        anchorOrigin={{
                                            vertical: "bottom",
                                            horizontal: "right",
                                        }}
                                    >
                                        <Notifications fontSize="large" />
                                    </Badge>
                                </IconButton>
                            )}
                            {gerarQRCode && (
                                <div className={classes.botaoGerarQRCode}>
                                    <Button
                                        onClick={() =>
                                            history.push("/servicos/ferramenta/pedido-de-mesa")
                                        }
                                        variant="contained"
                                    >
                                        Gerar QRCodes
                                    </Button>
                                </div>
                            )}
                            {botaoModoVisualizacao && (
                                <div className={classes.botaoQRCode}>
                                    <Button
                                        variant="contained"
                                        color="default"
                                        onClick={() => setTabStatus("VIEW")}
                                    >
                                        Ativar Modo Visualização
                                    </Button>
                                </div>
                            )}
                        </div>
                    </Toolbar>
                </AppBar>

                <Drawer
                    variant="permanent"
                    className={clsx(classes.drawer, {
                        [classes.drawerOpen]: openBarraLateral,
                        [classes.drawerClose]: !openBarraLateral,
                    })}
                    classes={{
                        paper: clsx(classes.scrollbarCustom, {
                            [classes.drawerOpen]: openBarraLateral,
                            [classes.drawerClose]: !openBarraLateral,
                        }),
                    }}
                >
                    <div className={classes.drawerHeaderMini}>
                        <IconButton
                            onClick={openBarraLateral ? handleDrawerClose : handleDrawerOpen}
                        >
                            {openBarraLateral ? (
                                <ChevronLeft style={{ color: "white" }} />
                            ) : (
                                <Menu style={{ color: "white" }} />
                            )}
                        </IconButton>
                    </div>
                    <Divider style={{ padding: "0", backgroundColor: "white" }} />

                    {openBarraLateral ? (
                        menuContent()
                    ) : isPerfilWhatsappOperador ? (
                        <div>
                            <List>
                                <Tooltip title="Menu" placement="right">
                                    <ListItem
                                        button
                                        onClick={() => {
                                            history.push("/servicos")
                                        }}
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            minHeight: "60px",
                                        }}
                                    >
                                        <Dashboard style={{ marginBottom: "2px" }} />
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "9px",
                                                color: "#bdc3c7",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Menu
                                        </Typography>
                                    </ListItem>
                                </Tooltip>
                                <Tooltip title="Chat" placement="right">
                                    <ListItem
                                        button
                                        onClick={() =>
                                            history.push("/servicos/modulo/conversas-whatsapp")
                                        }
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            minHeight: "60px",
                                        }}
                                    >
                                        <Chat style={{ marginBottom: "2px" }} />
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "9px",
                                                color: "#bdc3c7",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Chat
                                        </Typography>
                                    </ListItem>
                                </Tooltip>
                                <Tooltip title="Cadastrar templates" placement="right">
                                    <ListItem
                                        button
                                        onClick={() =>
                                            history.push(
                                                "/servicos/modulo/criar-template-whatsapp"
                                            )
                                        }
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            minHeight: "60px",
                                        }}
                                    >
                                        <PostAdd style={{ marginBottom: "2px" }} />
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "9px",
                                                color: "#bdc3c7",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Cadastrar
                                            <br />
                                            templates
                                        </Typography>
                                    </ListItem>
                                </Tooltip>
                                <Tooltip title="Disparar templates" placement="right">
                                    <ListItem
                                        button
                                        onClick={() =>
                                            history.push(
                                                "/servicos/modulo/envio-template-whatsapp-grupo"
                                            )
                                        }
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            minHeight: "60px",
                                        }}
                                    >
                                        <Send style={{ marginBottom: "2px" }} />
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "9px",
                                                color: "#bdc3c7",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Disparar
                                            <br />
                                            templates
                                        </Typography>
                                    </ListItem>
                                </Tooltip>
                                <Tooltip title="Sair" placement="right">
                                    <ListItem
                                        button
                                        onClick={() => {
                                            setDialogSair(true)
                                        }}
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            minHeight: "60px",
                                        }}
                                    >
                                        <ExitToAppIcon style={{ marginBottom: "2px" }} />
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "9px",
                                                color: "#bdc3c7",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Sair
                                        </Typography>
                                    </ListItem>
                                </Tooltip>
                            </List>
                        </div>
                    ) : (
                        <div>
                            <List>
                                {/* <Tooltip title="Fatura Disponível" placement="right">
                                    <ListItem
                                        button
                                        onClick={handleFatura}
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            backgroundColor: "#27ae60",
                                            margin: "4px 8px",
                                            borderRadius: "8px",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: "18px",
                                                marginBottom: "2px",
                                                color: "white",
                                            }}
                                        >
                                            $
                                        </span>
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "10px",
                                                color: "white",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Fatura
                                            <br />
                                            Disponível
                                        </Typography>
                                    </ListItem>
                                </Tooltip> */}

                                <Tooltip title="Sistema Administrativo" placement="right">
                                    <ListItem
                                        button
                                        onClick={handleSistemaAdm}
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            minHeight: "60px",
                                        }}
                                    >
                                        <AttachFile style={{ marginBottom: "2px" }} />
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "9px",
                                                color: "#bdc3c7",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Sistema
                                            <br />
                                            Administrativo
                                        </Typography>
                                    </ListItem>
                                </Tooltip>

                                <Tooltip title="Menu" placement="right">
                                    <ListItem
                                        button
                                        onClick={() => {
                                            history.push("/servicos")
                                        }}
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            minHeight: "60px",
                                        }}
                                    >
                                        <Dashboard style={{ marginBottom: "2px" }} />
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "9px",
                                                color: "#bdc3c7",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Menu
                                        </Typography>
                                    </ListItem>
                                </Tooltip>

                                <Tooltip title="Pedidos" placement="right">
                                    <ListItem
                                        button
                                        onClick={handleOpenPedidos}
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            minHeight: "60px",
                                        }}
                                    >
                                        <Receipt style={{ marginBottom: "2px" }} />
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "9px",
                                                color: "#bdc3c7",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Pedidos
                                        </Typography>
                                    </ListItem>
                                </Tooltip>

                                {mostrarCardapio && (
                                    <Tooltip title="Cardápio" placement="right">
                                        <ListItem
                                            button
                                            onClick={handleOpenCardapio}
                                            style={{
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                padding: "8px 4px",
                                                minHeight: "60px",
                                            }}
                                        >
                                            <MenuBook style={{ marginBottom: "2px" }} />
                                            <Typography
                                                variant="caption"
                                                style={{
                                                    fontSize: "9px",
                                                    color: "#bdc3c7",
                                                    textAlign: "center",
                                                    lineHeight: 1,
                                                }}
                                            >
                                                Cardápio
                                            </Typography>
                                        </ListItem>
                                    </Tooltip>
                                )}

                                <Tooltip title="Cadastros" placement="right">
                                    <ListItem
                                        button
                                        onClick={handleOpenCadastros}
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            minHeight: "60px",
                                        }}
                                    >
                                        <AddBox style={{ marginBottom: "2px" }} />
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "9px",
                                                color: "#bdc3c7",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Cadastros
                                        </Typography>
                                    </ListItem>
                                </Tooltip>

                                <Tooltip title="Financeiro" placement="right">
                                    <ListItem
                                        button
                                        onClick={handleOpenFinanceiro}
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            minHeight: "60px",
                                        }}
                                    >
                                        <Store style={{ marginBottom: "2px" }} />
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "9px",
                                                color: "#bdc3c7",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Financeiro
                                        </Typography>
                                    </ListItem>
                                </Tooltip>

                                {parametros.PUBLIC_HABILITAR_AGENDAMENTO && (
                                    <Tooltip title="Agendamento" placement="right">
                                        <ListItem
                                            button
                                            onClick={handleOpenAgendamento}
                                            style={{
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                padding: "8px 4px",
                                                minHeight: "60px",
                                            }}
                                        >
                                            <AccessAlarm style={{ marginBottom: "2px" }} />
                                            <Typography
                                                variant="caption"
                                                style={{
                                                    fontSize: "9px",
                                                    color: "#bdc3c7",
                                                    textAlign: "center",
                                                    lineHeight: 1,
                                                }}
                                            >
                                                Agendamento
                                            </Typography>
                                        </ListItem>
                                    </Tooltip>
                                )}

                                <Tooltip title="Utilitários" placement="right">
                                    <ListItem
                                        button
                                        onClick={handleOpenUtilitarios}
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            minHeight: "60px",
                                        }}
                                    >
                                        <Settings style={{ marginBottom: "2px" }} />
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "9px",
                                                color: "#bdc3c7",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Utilitários
                                        </Typography>
                                    </ListItem>
                                </Tooltip>
                                {/* <Tooltip title="Retrospectiva" placement="right">
                                        <ListItem
                                            button
                                            onClick={() => {
                                                const b64 = btoa(
                                                    `id:${estabelecimentoId};data:2025-01-01T00:00:00`
                                                )

                                                window.open(
                                                    `https://painel.clientefiel.app/retrospectiva?b64=${b64}`,
                                                    "_blank"
                                                )
                                            }}
                                            style={{
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                padding: "8px 4px",
                                                minHeight: "60px",
                                            }}
                                        >
                                            <Cake style={{ marginBottom: "2px" }} />
                                            <Typography
                                                variant="caption"
                                                style={{
                                                    fontSize: "9px",
                                                    color: "#bdc3c7",
                                                    textAlign: "center",
                                                    lineHeight: 1,
                                                }}
                                            >
                                                Retrospectiva
                                            </Typography>
                                        </ListItem>
                                    </Tooltip> */}

                                <Tooltip title="Sair" placement="right">
                                    <ListItem
                                        button
                                        onClick={() => {
                                            setDialogSair(true)
                                        }}
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            minHeight: "60px",
                                        }}
                                    >
                                        <ExitToAppIcon style={{ marginBottom: "2px" }} />
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "9px",
                                                color: "#bdc3c7",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Sair
                                        </Typography>
                                    </ListItem>
                                </Tooltip>
                            </List>
                        </div>
                    )}
                </Drawer>

                <Drawer
                    variant="temporary"
                    anchor="left"
                    open={mobileDrawerOpen}
                    onClose={handleMobileDrawerToggle}
                    className={classes.mobileDrawer}
                    classes={{
                        paper: clsx(classes.scrollbarCustom, classes.drawerOpen),
                    }}
                    ModalProps={{
                        keepMounted: true,
                    }}
                >
                    <div className={classes.drawerHeaderMini}>
                        <IconButton onClick={handleMobileDrawerToggle}>
                            <ChevronLeft style={{ color: "white" }} />
                        </IconButton>
                    </div>
                    <Divider style={{ padding: "0", backgroundColor: "white" }} />
                    {menuContent()}
                </Drawer>
            </div>

            <Popover
                open={openPedidos}
                anchorEl={anchorElPedidos}
                onClose={handleClosePedidos}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
                <List dense>
                    <ListItem
                        button
                        onClick={() => {
                            handleAceitadorDePedidos()
                            handleClosePedidos()
                        }}
                    >
                        <ListItemText primary="Painel de Pedidos" />
                    </ListItem>
                    <ListItem
                        button
                        onClick={() => {
                            handleRegistradorDePedidos()
                            handleClosePedidos()
                        }}
                    >
                        <ListItemText primary="Registrador de Pedidos" />
                    </ListItem>
                    <ListItem
                        button
                        onClick={() => {
                            handlePedidoDeMesa()
                            handleClosePedidos()
                        }}
                    >
                        <ListItemText primary="Pedidos de Mesa" />
                    </ListItem>
                </List>
            </Popover>

            {parametros.PUBLIC_HABILITAR_AGENDAMENTO && (
                <Popover
                    open={openCadastros}
                    anchorEl={anchorElCadastros}
                    onClose={handleCloseCadastros}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                >
                    <List dense>
                        <ListItem
                            button
                            onClick={() => {
                                handleAreaDeEntrega()
                                handleCloseCadastros()
                            }}
                        >
                            <ListItemText primary="Área de Entrega" />
                        </ListItem>
                    </List>
                </Popover>
            )}

            <Popover
                open={openFinanceiro}
                anchorEl={anchorElFinanceiro}
                onClose={handleCloseFinanceiro}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
                <List dense>
                    <ListItem
                        button
                        onClick={() => {
                            history.push("/servicos/modulo/caixa")
                            handleCloseFinanceiro()
                        }}
                    >
                        <ListItemText primary="Caixa" />
                    </ListItem>
                    <ListItem
                        button
                        onClick={() => {
                            handleNotaFiscal()
                            handleCloseFinanceiro()
                        }}
                    >
                        <ListItemText primary="Emissão fiscal" />
                    </ListItem>
                </List>
            </Popover>

            {parametros.PUBLIC_HABILITAR_AGENDAMENTO && (
                <Popover
                    open={openAagendamento}
                    anchorEl={anchorAgendamento}
                    onClose={handleCloseAgendamento}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                    }}
                >
                    <List>
                        <ListItem
                            button
                            key="Pedidos Agendados"
                            onClick={() => history.push("/servicos/modulo/pedidos-agendados")}
                        >
                            Pedidos Agendados
                        </ListItem>
                        <ListItem
                            button
                            key="Periodos de agendamentos"
                            onClick={() => history.push("/servicos/modulo/agendamento-periodos")}
                        >
                            Periodos de agendamentos
                        </ListItem>
                        <ListItem
                            button
                            key="Configurações de agendamento"
                            onClick={() =>
                                history.push("/servicos/modulo/agendamento-configuracoes")
                            }
                        >
                            Configurações de agendamento
                        </ListItem>
                    </List>
                </Popover>
            )}

            <Popover
                open={openUtilitarios}
                anchorEl={anchorElUtilitarios}
                onClose={handleCloseUtilitarios}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <List>
                    <ListItem
                        button
                        key="Alterar Estabelecimento"
                        onClick={handleToggleDialogAlterarEstabelecimento}
                    >
                        Alterar Estabelecimento
                    </ListItem>
                    <ListItem button key="Atendente Virtual (Izza)" onClick={handleIzzaBot}>
                        Atendente Virtual (Izza)
                    </ListItem>
                    <ListItem button key="Gerador de QrCode" onClick={handleGeradorQrCode}>
                        Gerador de QrCode
                    </ListItem>
                    <ListItem
                        button
                        key="Conversas do Whatsapp"
                        onClick={() => {
                            history.push("/servicos/modulo/conversas-whatsapp")
                            handleCloseUtilitarios()
                        }}
                    >
                        Conversas do Whatsapp
                    </ListItem>
                    {perfilUsuario === "CLIENTEFIEL" && (
                        <ListItem
                            button
                            key="Envio template WhatsApp (grupo)"
                            onClick={() => {
                                history.push("/servicos/modulo/envio-template-whatsapp-grupo")
                                handleCloseUtilitarios()
                            }}
                        >
                            Envio template WhatsApp (grupo)
                        </ListItem>
                    )}
                    {perfilUsuario === "CLIENTEFIEL" && (
                        <ListItem
                            button
                            key="Criar template WhatsApp"
                            onClick={() => {
                                history.push("/servicos/modulo/criar-template-whatsapp")
                                handleCloseUtilitarios()
                            }}
                        >
                            Criar template WhatsApp
                        </ListItem>
                    )}
                </List>
            </Popover>

            <Popover
                open={openCardapio}
                anchorEl={anchorElCardapio}
                onClose={handleCloseCardapio}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
                <List dense>
                    <ListItem
                        button
                        selected={tela === "produtos"}
                        onClick={() => {
                            history.push("/servicos/ferramenta/edicao-cardapio/produtos")
                            handleCloseCardapio()
                        }}
                    >
                        <ListItemText primary="Produtos" />
                    </ListItem>

                    <ListItem
                        button
                        selected={tela === "massa"}
                        onClick={() => {
                            history.push("/servicos/ferramenta/edicao-cardapio/massa")
                            handleCloseCardapio()
                        }}
                    >
                        <ListItemText primary="Edição em Massa" />
                    </ListItem>

                    <ListItem
                        button
                        selected={tela === "insumos"}
                        onClick={() => {
                            history.push("/servicos/ferramenta/edicao-cardapio/insumos")
                            handleCloseCardapio()
                        }}
                    >
                        <ListItemText primary="Estoque" />
                    </ListItem>

                    <ListItem
                        button
                        selected={tela === "ficha-tecnica"}
                        onClick={() => {
                            history.push("/servicos/ferramenta/edicao-cardapio/ficha-tecnica")
                            handleCloseCardapio()
                        }}
                    >
                        <ListItemText primary="Fichas Técnicas" />
                    </ListItem>
                </List>
            </Popover>
        </>
    )
}
